import { getNowDatetime } from '../helpers/DateHelper';

export function downloadFile (fileContent, fileName, fileExtension) {
    try {
        const fileURL = window.URL.createObjectURL(fileContent);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = `${fileName}.${fileExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(fileURL);
    } catch (error) {
        throw Error('Ocorreu um erro ao realizar o download do arquivo.');
    }
}

export function getFileNameWithSalt(fileName) {
    return `${fileName}_${getNowDatetime(true)}`;
}
